import { Guid } from "@alm/flow-ds/utils";

export interface AlertConfig {
	className?: string;
	dark?: boolean;
	description?: string;
	icon?: string;
	iconWeight?: "r" | "l" | "b" | "d" | "s";
	list?: string[];
	status?: "warning" | "info" | "error" | "success";
	timeout?: number;
	title: string;
}

export interface Alert extends Readonly<AlertConfig> {
	id: string;
}

export function createAlert(newAlert: AlertConfig): Readonly<Alert> {
	return {
		id: Guid(),
		...newAlert,
	};
}
